<nav #sidebar class="sidebar">
  <ng-content select="[side-nav]"></ng-content>
</nav>
<div class="content"><ng-content select="[side-nav-content]"></ng-content></div>
